import { React, useState, useEffect } from 'react'
import { Button, Modal, Form } from "react-bootstrap";
import { ApiManager } from "../../ApiManager"
import { handleApiError } from "../../utils/apiErrorHandler";

const RecommendationModal = (props) => {

    const handleClose = () => props.setShowRecommendationModal(false);
    const recommendation = props.recommendation;
    const [recommendationValue, setRecommendationValue] = useState(recommendation.Value);

    // The modal stays mounted across open/close, so mount-time state goes stale —
    // saving without retyping used to send Value: undefined and wipe the stored text
    useEffect(() => {
        if (props.showRecommendationModal)
            setRecommendationValue(recommendation.Value ?? "");
    }, [props.showRecommendationModal, recommendation]);

    const handleSaveRecommendation = () => {
        var recommendationToAdd = {
            Value: recommendationValue,
            Enabled: true,
            Id: recommendation.Id
        };
        ApiManager.getInstance().updateRecommendation(recommendationToAdd).then(() => {
            props.setShowRecommendationModal(false);
            props.getAllRecommendations();
        }).catch(handleApiError);
    };

    return (
        <Modal show={props.showRecommendationModal} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Recommendation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form className="row g-3">
                    <Form.Group>
                        <Form.Label>Recommendation</Form.Label>
                        <Form.Control onChange={(e) => setRecommendationValue(e.target.value)} as="textarea" autoFocus rows={1} value={recommendationValue ?? ""} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={handleClose}> Close </Button>
                <Button variant="outline-primary" onClick={handleSaveRecommendation}>Save</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RecommendationModal;